import React, { useState } from "react";
import axios from "axios";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

const AddProduct = () => {
  const [product, setProduct] = useState({
    name: "",
    price: "",
    description: "",
    image: null,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setProduct((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleImageUpload = async (imageFile) => {
    const data = new FormData();
    data.append("file", imageFile);
    data.append("upload_preset", "salma_pro"); // استبدل باسم الـ preset بتاعك
    data.append("cloud_name", "dys8jv8c2");

    const res = await axios.post(
      "https://api.cloudinary.com/v1_1/dys8jv8c2/upload",
      data
    );
    return res.data.secure_url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let imageUrl = null;
      if (product.image) {
        imageUrl = await handleImageUpload(product.image);
      }

      await addDoc(collection(db, "products"), {
        name: product.name,
        price: parseFloat(product.price),
        description: product.description,
        imageUrl,
        createdAt: new Date(),
      });

      alert("✅ تم إضافة المنتج بنجاح!");
      setProduct({ name: "", price: "", description: "", image: null });
    } catch (err) {
      console.error("Error adding product:", err);
      alert("حدث خطأ أثناء الإضافة!");
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>🛒 إضافة منتج جديد</h2>
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          style={styles.input}
          type="text"
          name="name"
          placeholder="اسم المنتج"
          value={product.name}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="number"
          name="price"
          placeholder="السعر"
          value={product.price}
          onChange={handleChange}
          required
        />
        <textarea
          style={styles.textarea}
          name="description"
          placeholder="الوصف"
          value={product.description}
          onChange={handleChange}
          required
        ></textarea>
        <input
          style={styles.fileInput}
          type="file"
          name="image"
          accept="image/*"
          onChange={handleChange}
        />
        <button style={styles.button} type="submit" disabled={loading}>
          {loading ? "جاري الإضافة..." : "إضافة المنتج"}
        </button>
      </form>
    </div>
  );
};

// 🎨 CSS داخل نفس الكمبوننت
const styles = {
  container: {
    backgroundColor: "#f9fafb",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 20px",
  },
  title: {
    fontSize: "28px",
    color: "#1f2937",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  form: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "450px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  input: {
    padding: "12px 15px",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    fontSize: "16px",
  },
  textarea: {
    padding: "12px 15px",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    fontSize: "16px",
    resize: "none",
    minHeight: "100px",
  },
  fileInput: {
    border: "1px dashed #9ca3af",
    padding: "10px",
    borderRadius: "10px",
    backgroundColor: "#f3f4f6",
  },
  button: {
    backgroundColor: "#2563eb",
    color: "#fff",
    fontSize: "16px",
    padding: "12px",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
  },
};

export default AddProduct;
